//innerStroke means blue stroke //outerStroke means grey stroke

<template>
  <div :id="id" class="radial-progress-container" :style="containerStyle">
    <svg
      class="radial-progress-bar"
      :width="diameter"
      :height="diameter"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <filter id="dropshadow" height="130%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="1.5" />
        <!-- stdDeviation is how much to blur -->
        <feOffset dx="0" dy="2" result="offsetblur" />
        <!-- how much to offset -->
        <feComponentTransfer>
          <feFuncA type="linear" slope="0.5" />
          <!-- slope is the opacity of the shadow -->
        </feComponentTransfer>
        <feMerge>
          <feMergeNode />
          <!-- this contains the offset blurred image -->
          <feMergeNode in="SourceGraphic" />
          <!-- this contains the element that the filter is applied to -->
        </feMerge>
      </filter>

      <circle
        :transform="'rotate(' + rotation + ', ' + radius + ',' + radius + ')'"
        :r="innerCircleRadius + 0.8"
        :cx="radius"
        :cy="radius"
        fill="#EFF0F1"
        :stroke="innerStrokeColor"
        :stroke-dasharray="isHideProgress ? domainRadius : circumference"
        :stroke-dashoffset="circumference"
        stroke-linecap="round"
        :style="innerStrokeStyle"
      />

      <circle
        v-if="!isHideProgress"
        :transform="
          'rotate(' + (rotation + 6) + ',' + radius + ',' + radius + ')'
        "
        :r="innerCircleRadius + 0.8"
        :cx="radius"
        :cy="radius"
        fill="transparent"
        :stroke="outerStrokeColor"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="circumference"
        stroke-linecap="square"
        :style="outerStrokestyle"
      />
      <circle
        v-if="!isHideProgress"
        :transform="'rotate(' + rotation + ',' + radius + ',' + radius + ')'"
        :r="innerCircleRadius + 0.8"
        :cx="radius"
        :cy="radius"
        fill="transparent"
        :stroke="outerStrokeColor"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="circumference"
        stroke-linecap="round"
        :style="outerStrokestyle"
      />
      <circle
        :r="innerCircleRadius / 1.11"
        :cx="radius"
        :cy="radius"
        fill="white"
        style="filter: url(#dropshadow)"
      />
      <circle
        :r="innerCircleRadius / 1.58"
        :cx="radius"
        :cy="radius"
        fill="white"
        style="filter: url(#dropshadow)"
      />

      <circle
        v-if="isHideResponsive"
        id="circle3"
        :r="innerCircleRadius / 2.7"
        :cx="radius"
        :cy="radius"
        fill="white"
        style="filter: url(#dropshadow)"
        class="hideCircle-xs"
      />
      <circle
        v-else
        :r="innerCircleRadius / 2.7"
        :cx="radius"
        :cy="radius"
        fill="white"
        style="filter: url(#dropshadow)"
      />
      <text
        v-if="!isHideProgress"
        x="50%"
        y="53%"
        class="progress-text"
        text-anchor="middle"
        alignment-baseline="middle"
        font-size="10"
      >
        {{ Math.round(finishedPercentage) }}%
      </text>
    </svg>
  </div>
</template>

<script lang="ts">
import { Component, Watch, Prop } from "vue-facing-decorator";
import { Vue } from "vue-facing-decorator";

@Component({
  components: {},
})
export default class RadialProgressBar extends Vue {
  public strokeDashoffset = 0;
  public strokeDashoffset1 = 0;
  public diameter = 100;
  public checksum = 2.6;
  public animateSpeed = process.env["VUE_APP_PROGRESS_SPEED"]
    ? parseInt(process.env["VUE_APP_PROGRESS_SPEED"])
    : 1500;
  /** Outer Stroke Color */
  @Prop({ type: String, required: false, default: "#EEEFF0" })
  outerStrokeColor!: string;
  /** Animation rotation (degree) */
  @Prop({ type: Number, required: false, default: 270 })
  rotation!: number;
  /** Total number of steps */
  @Prop({ type: Number, required: true, default: 10 })
  totalSteps!: number;
  /** Completed number of steps*/
  @Prop({ type: [Number, String], required: true, default: 5 })
  completedSteps!: [number, string];
  /** Inner Stroke Color */
  @Prop({ type: String, required: false, default: "#48A0FF" })
  innerStrokeColor!: string;
  // @Prop({type: Boolean,required: false,default: true})
  // isClockwise!: boolean;
  /** Check show or hide progress number */
  @Prop({ type: Boolean, required: false, default: false })
  isHideProgress!: boolean;

  @Prop({ type: Number, required: false, default: 72 })
  diameterDefault!: number;

  @Prop({ type: Boolean, required: false, default: true })
  isHideResponsive!: number;

  @Prop({ type: String, required: false, default: "" })
  id!: string;

  get innerStrokeWidth() {
    return this.diameter / 13;
  }
  get strokeWidth() {
    return this.diameter / 13;
  }
  get radius() {
    return this.diameter / 2;
  }
  get circumference() {
    return Math.PI * this.innerCircleDiameter;
  }
  get stepSize() {
    if (this.totalSteps === 0) {
      return 0;
    }
    return 100 / this.totalSteps;
  }
  get finishedPercentage() {
    return this.stepSize * +this.completedSteps;
  }
  get finishedPercentageOuterStroke() {
    return this.stepSize * (+this.completedSteps - 1);
  }
  get innerCircleDiameter() {
    return this.diameter - this.innerStrokeWidth * 2;
  }
  get innerCircleRadius() {
    return this.innerCircleDiameter / 2;
  }
  get containerStyle() {
    return {
      height: `${this.diameter}px`,
      width: `${this.diameter}px`,
    };
  }
  get domainRadius() {
    return (this.innerCircleRadius + 0.8) * 2 * Math.PI;
  }
  get outerStrokestyle() {
    return {
      visibility: +this.completedSteps < 2 ? "hidden" : "visible",
      height: `${this.diameter}px`,
      width: `${this.diameter}px`,
      strokeWidth: `${this.strokeWidth + 0.5}px`,
      strokeDashoffset: this.strokeDashoffset1,
      transition: `stroke-dashoffset ${this.animateSpeed}ms linear`,
    };
  }
  get innerStrokeStyle() {
    return {
      height: `${this.diameter}px`,
      width: `${this.diameter}px`,
      strokeWidth: `${this.strokeWidth}px`,
      strokeDashoffset: this.strokeDashoffset,
      transition: `stroke-dashoffset ${this.animateSpeed}ms linear`,
    };
  }
  get innerCircleStyle() {
    return {
      width: `${this.innerCircleDiameter}px`,
    };
  }

  changeProgress() {
    this.strokeDashoffset = this.isHideProgress
      ? (this.domainRadius * (100 - this.finishedPercentage)) / 100
      : ((100 - this.finishedPercentage) / 100) * this.circumference;
    this.strokeDashoffset1 =
      ((100 - this.finishedPercentageOuterStroke) / 100) * this.circumference +
      this.diameter / 10;
    if (this.finishedPercentage > 90) {
      this.strokeDashoffset += this.checksum;
      this.strokeDashoffset1 += this.checksum;
    }
    if (this.finishedPercentage === 100 && this.isHideProgress) {
      this.strokeDashoffset = 0;
      this.strokeDashoffset1 = 0;
    }
  }
  mobileOptimizer() {
    var w = window.innerWidth;
    if (w < 768 && this.isHideResponsive) {
      this.diameter = this.diameter / 1.8;
      this.checksum = 0.5;
    } else {
      this.diameter = this.isHideProgress
        ? this.diameterDefault
        : this.diameter;
      this.checksum = 2.6;
    }
  }

  @Watch("totalSteps")
  ChangeTotalSteps() {
    this.changeProgress();
  }
  @Watch("completedSteps")
  changeCompletedSteps() {
    this.changeProgress();
  }
  @Watch("diameter")
  changeDiameter() {
    this.changeProgress();
  }

  created() {
    this.changeProgress();
    window.addEventListener("resize", this.mobileOptimizer);
    this.mobileOptimizer();
  }
  destroyed() {
    window.removeEventListener("resize", this.mobileOptimizer);
  }
}
</script>

<style lang="scss" scoped>
.radial-progress-container {
  position: relative;
}

.radial-progress-inner {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
  border-radius: 50%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.hideCircle {
  display: none;
}

.progress-text {
  position: absolute;
  width: 20px;
  height: 15px;
  left: 24px;
  top: 31px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 15px;
  /* identical to box height */

  text-align: center;

  /* UI / Grey Text */

  fill: #878787;
}

@media (max-width: 767px) {
  #circle3 {
    display: none;
  }
}
</style>
